import { render, staticRenderFns } from "./vPeriodo.vue?vue&type=template&id=641c79ad&scoped=true&"
import script from "./vPeriodo.vue?vue&type=script&lang=js&"
export * from "./vPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./vPeriodo.vue?vue&type=style&index=0&id=641c79ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c79ad",
  null
  
)

export default component.exports